<script>
import Layout from '@layouts/guest.vue'
import { authComputed, authMethods } from '@state/helpers'
import ConfirmAccount from '@guest/components/confirm-account.vue'

export default {
  page: {
    meta: [{ name: 'description', content: `Log in to KyndHub` }],
  },
  components: { Layout, ConfirmAccount },
  props: {
    token: {
      type: String,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      email: '',
      confirmAccountError: '',
      tryingToLogIn: false,
    }
  },
  computed: { ...authComputed },
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    postConfirmAccount(params) {
      this.tryingToLogIn = true
      // Reset the authError if it existed.
      this.confirmAccountError = ''
      return this.confirmAccount({
        email: params.email,
        userId: this.userId,
        token: this.token,
      }).then((response) => {
        if (response.message) {
          this.confirmAccountError = 'non_existing_user'
        } else {
        }
      })
    },
    clearConfirmAccountErrors() {
      this.confirmAccountError = ''
    },
  },
}
</script>

<template>
  <Layout>
    <ConfirmAccount
      :trying-to-login="tryingToLogIn"
      :confirm-account-error="confirmAccountError"
      :is-trying-to-login="isTryingToLogin"
      @post-confirm-account="postConfirmAccount"
      @clear-confirm-account-errors="clearConfirmAccountErrors"
    ></ConfirmAccount>
  </Layout>
</template>
